/**
 * Promo temp solution banner
 */
document.addEventListener('DOMContentLoaded', function () {
  const promoBanner = document.getElementById('promoBanner');
  const closeBannerBtn = document.getElementById('closeBanner');

  promoBanner.addEventListener('click', function () {
    window.location.href = '/memberships';
  });

  closeBannerBtn.addEventListener('click', function(event) {
    event.stopPropagation(); //
    promoBanner.style.display = 'none';
  });
});



(function($){

  /**
   * THE MAIN SCRIPT CONSTRUCTOR
   */

  function scriptConstructor() {

    console.log('DOM is ready');
  }

  $(window).ready(scriptConstructor);

  /**
   * THE CODE TO LOAD ONLY WHEN PAGE HAS FULLY LOADED
   */

  let interval = setInterval(function() {
    'use strict';
    if(document.readyState === 'complete') {
      clearInterval(interval);
      console.log('Page has finished loading');
    }
  }, 100);
})(jQuery);
